import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cdp-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: false
})
export class ConfirmationModalComponent {
    @Input()
    showButtonSpinner = false;

    @Input()
    infoTooltip: string;

    @Input()
    saveButtonText: string;

    @Input()
    savingButtonText: string;

    @Input()
    saveButtonStyle: string;

    @Input()
    disableConfirm: boolean;

    @Output()
    confirmClicked: EventEmitter<void> = new EventEmitter();

    @Output()
    cancelClicked: EventEmitter<void> = new EventEmitter();
}
